module.exports = __webpack_public_path__ + "img/xander.0011a6af.png";